import { services } from "../data/services";

/** "/web-development/" → "web-development" */
export function hrefToSlug(href) {
  if (!href) return "";
  return href.replace(/^\/+|\/+$/g, "");
}

export function getServiceBySlug(serviceName) {
  if (!serviceName || typeof serviceName !== "string") return null;
  const key = decodeURIComponent(serviceName).trim().toLowerCase();
  return (
    services.find((s) => hrefToSlug(s.href).toLowerCase() === key) || null
  );
}

export function servicePath(service) {
  const slug = hrefToSlug(service?.href);
  return slug ? `/service/${slug}` : "/";
}
